import { BildirimSatiri } from '../services/BildirimService';

/**
 * Üst bar zili yardımcıları (30.10.2026, #512). Yeni kayıt = bir satırın adedi arttı ya da yeni satır geldi; o zaman zil çalar.
 * Son görülen adetler tarayıcıda firma başına saklanır: sayfa yenilenince eski kayıtlar için yeniden çalmaz.
 */

export type ZilSayaclari = Record<string, number>;

export const sayaclaraCevir = (satirlar: BildirimSatiri[]): ZilSayaclari =>
    Object.fromEntries(satirlar.map(x => [x.kod, x.adet]));

/** İlk açılışta (önceki kayıt yok) uyarı yok; adet artınca ya da yeni satır gelince var; düşünce yok. */
export const yeniBildirimVar = (onceki: ZilSayaclari | undefined, simdi: ZilSayaclari): boolean => {
    if (!onceki)
        return false;
    return Object.keys(simdi).some(k => simdi[k] > (onceki[k] ?? 0));
}

const anahtar = (firmaId: string | undefined) => 'bildirim-zili-sayac-' + (firmaId ?? '');

export const sayaclariOku = (firmaId: string | undefined): ZilSayaclari | undefined => {
    try {
        const s = localStorage.getItem(anahtar(firmaId));
        return s ? JSON.parse(s) : undefined;
    } catch {
        return undefined;
    }
}

export const sayaclariYaz = (firmaId: string | undefined, sayaclar: ZilSayaclari) => {
    try {
        localStorage.setItem(anahtar(firmaId), JSON.stringify(sayaclar));
    } catch {
        // Saklanamazsa yalnız bu oturumda karşılaştırılır.
    }
}

/** Kısa iki tonlu uyarı. Tarayıcı sese henüz izin vermiyorsa (sayfayla etkileşim yok) ilk tıklamada çalar. */
export const zilSesiCal = () => {
    try {
        const AC = window.AudioContext || (window as any).webkitAudioContext;
        if (!AC)
            return;
        const c = new AC();
        const cal = () => {
            [[880, 0], [1175, 0.16]].forEach(([frekans, gecikme]) => {
                const o = c.createOscillator();
                const g = c.createGain();
                o.frequency.value = frekans;
                o.connect(g);
                g.connect(c.destination);
                g.gain.setValueAtTime(0.15, c.currentTime + gecikme);
                g.gain.exponentialRampToValueAtTime(0.0001, c.currentTime + gecikme + 0.25);
                o.start(c.currentTime + gecikme);
                o.stop(c.currentTime + gecikme + 0.27);
            });
        };
        if (c.state === 'suspended') {
            const ilkTiklama = () => { c.resume().then(cal).catch(() => undefined); };
            document.addEventListener('click', ilkTiklama, { once: true });
            c.resume().then(() => {
                if (c.state === 'running') {
                    document.removeEventListener('click', ilkTiklama);
                    cal();
                }
            }).catch(() => undefined);
        } else {
            cal();
        }
    } catch {
        // Ses çalınmazsa sallanma yine çalışır.
    }
}
